import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgHuurOpzeggen = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#A8D3AF"
      fillRule="evenodd"
      d="M10 34h20V12l-3.01-3.01L24 6H10v28"
      clipRule="evenodd"
    />
    <path
      fill="#6FBC85"
      fillRule="evenodd"
      d="m24 6 3 3 3 3h-6z"
      clipRule="evenodd"
    />
    <path
      fill="#6FBC85"
      d="M22 11.48H12v1.05h10zM21 14.48h-9v1.05h9zM22.71 22.48H12v1.05h10.71zM18 25.48h-6v1.05h6z"
    />
    <path
      fill="#00A75D"
      d="m33 20-3-3-4.5 4.5L21 17l-3 3 4.5 4.5L18 29l3 3 4.5-4.5L30 32l3-3-4.5-4.5z"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgHuurOpzeggen);

export default ForwardRef;
